var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_407",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29261",
    "data-name": "Group 29261",
    transform: "translate(509 11099)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -509, -11099)",
    filter: "url(#Ellipse_407)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_407-2",
    "data-name": "Ellipse 407",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_11_",
    "data-name": "svgexport-17 (11)",
    transform: "translate(-486.713 -11079.713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50010",
    "data-name": "Path 50010",
    d: "M136.19,18.647a6.222,6.222,0,0,1-6.209-6.221V6.447a6.209,6.209,0,1,1,12.417,0v5.979A6.222,6.222,0,0,1,136.19,18.647Z",
    transform: "translate(-122.764 -0.213)",
    fill: "#dada3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50011",
    "data-name": "Path 50011",
    d: "M241.808.226V18.647a6.222,6.222,0,0,0,6.209-6.221V6.447A6.222,6.222,0,0,0,241.808.226Z",
    transform: "translate(-228.383 -0.213)",
    fill: "#9dbc29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50012",
    "data-name": "Path 50012",
    d: "M193.3,107.925a.832.832,0,0,0-.831.833V111.3l-.554-.561a.832.832,0,0,0-1.181,1.172l1.735,1.756v15.853a.831.831,0,1,0,1.662,0V108.758A.832.832,0,0,0,193.3,107.925Z",
    transform: "translate(-179.919 -101.933)",
    fill: "#a34f3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50013",
    "data-name": "Path 50013",
    d: "M241.808,107.982V130.4a.831.831,0,0,0,.789-.831V108.813A.831.831,0,0,0,241.808,107.982Z",
    transform: "translate(-228.383 -101.987)",
    fill: "#873f2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50014",
    "data-name": "Path 50014",
    d: "M70.242,395.415a.832.832,0,0,1-.831-.833v-5.127a.831.831,0,1,1,1.662,0v5.127A.832.832,0,0,1,70.242,395.415Z",
    transform: "translate(-65.557 -367.046)",
    fill: "#c86e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50015",
    "data-name": "Path 50015",
    d: "M84.382,388.623v6.792a.832.832,0,0,0,.831-.833v-5.127A.832.832,0,0,0,84.382,388.623Z",
    transform: "translate(-79.697 -367.046)",
    fill: "#a34f3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50016",
    "data-name": "Path 50016",
    d: "M5.6,103.2c-1.345,0-2.563-.948-3.429-2.67a13,13,0,0,1-1.2-5.715c0-4.394,3.8-9.6,3.963-9.819a.83.83,0,0,1,1.337,0c.162.219,3.963,5.425,3.963,9.819a13,13,0,0,1-1.2,5.715c-.866,1.722-2.084,2.67-3.429,2.67Z",
    transform: "translate(-0.911 -79.962)",
    fill: "#dada3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50017",
    "data-name": "Path 50017",
    d: "M85.051,85a.831.831,0,0,0-.669-.338V103.2c1.345,0,2.563-.948,3.429-2.67a13,13,0,0,0,1.2-5.715C89.013,90.426,85.212,85.22,85.051,85Z",
    transform: "translate(-79.697 -79.962)",
    fill: "#9dbc29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50018",
    "data-name": "Path 50018",
    d: "M383.843,7.3a3.673,3.673,0,0,1-4.053-4.6,3.59,3.59,0,0,1,2.57-2.575A3.669,3.669,0,1,1,383.843,7.3Z",
    transform: "translate(-358.586 -0.001)",
    fill: "#ffdd54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50019",
    "data-name": "Path 50019",
    d: "M445.583,0V7.335A3.778,3.778,0,0,0,446.1,7.3a3.668,3.668,0,0,0-.518-7.3Z",
    transform: "translate(-420.844 -0.001)",
    fill: "#ffb454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50020",
    "data-name": "Path 50020",
    d: "M432.969,199.88a.832.832,0,0,1-.831-.833v-4.658a.831.831,0,1,1,1.662,0v4.658A.832.832,0,0,1,432.969,199.88Z",
    transform: "translate(-408.145 -182.81)",
    fill: "#ff405c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50021",
    "data-name": "Path 50021",
    d: "M147.671,187.064V176.1a.278.278,0,0,1,.093-.208l8.847-7.864a.277.277,0,0,1,.368,0l8.847,7.864a.278.278,0,0,1,.093.208v10.96H147.671Z",
    transform: "translate(-139.472 -158.637)",
    fill: "#fff2de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50022",
    "data-name": "Path 50022",
    d: "M321.043,175.9l-8.847-7.864a.276.276,0,0,0-.184-.07v19.1h9.124V176.1A.278.278,0,0,0,321.043,175.9Z",
    transform: "translate(-294.689 -158.637)",
    fill: "#fde4c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50023",
    "data-name": "Path 50023",
    d: "M192.579,349.912h-4.987v-8.7a.832.832,0,0,1,.831-.833h3.325a.832.832,0,0,1,.831.833Z",
    transform: "translate(-177.177 -321.486)",
    fill: "#a34f3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50024",
    "data-name": "Path 50024",
    d: "M347.854,359.409h-2.841a.588.588,0,0,1-.588-.589v-2.847a.589.589,0,0,1,.588-.589h2.841a.589.589,0,0,1,.588.589v2.847A.588.588,0,0,1,347.854,359.409Z",
    transform: "translate(-325.302 -335.653)",
    fill: "#c8ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50025",
    "data-name": "Path 50025",
    d: "M334.3,346.074h-4.017a.832.832,0,0,1-.831-.833v-4.025a.832.832,0,0,1,.831-.833H334.3a.832.832,0,0,1,.831.833v4.025A.832.832,0,0,1,334.3,346.074Zm-3.186-1.666h2.354V342.05h-2.354Z",
    transform: "translate(-311.163 -321.486)",
    fill: "#a34f3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50026",
    "data-name": "Path 50026",
    d: "M134.286,168.71a.827.827,0,0,1-.551-.21l-9.665-8.591L114.4,168.5a.832.832,0,0,1-1.1-1.246l10.217-9.081a.83.83,0,0,1,1.1,0l10.217,9.081a.833.833,0,0,1-.552,1.456Z",
    transform: "translate(-106.746 -149.193)",
    fill: "#ff405c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50027",
    "data-name": "Path 50027",
    d: "M322.781,167.253l-10.217-9.081a.828.828,0,0,0-.552-.21v1.946l9.665,8.591a.832.832,0,0,0,1.1-1.246Z",
    transform: "translate(-294.689 -149.192)",
    fill: "#e20059"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50028",
    "data-name": "Path 50028",
    d: "M27.6,483.486H.832A.848.848,0,0,1,0,482.643a.832.832,0,0,1,.831-.833H27.6a.832.832,0,0,1,.831.833.848.848,0,0,1-.831.843Z",
    transform: "translate(-0.001 -455.059)",
    fill: "#dada3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50029",
    "data-name": "Path 50029",
    d: "M269.4,481.81H256.024v1.676H269.4a.848.848,0,0,0,.831-.843A.832.832,0,0,0,269.4,481.81Z",
    transform: "translate(-241.809 -455.059)",
    fill: "#9dbc29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.ca6b01cc7d8cf98201b25b25ea08a6a9.svg";
export { ForwardRef as ReactComponent };